module.exports = __webpack_public_path__ + "img/tzszyy.c6cb66b3.png";